/**
 * FilterLayout - 검색창 + 필터 통합 레이아웃
 *
 * 데스크톱: 가로 배치 (검색 240px 고정, 필터 flex-1)
 * 모바일: 세로 배치
 */

import React from 'react';
import './FilterLayout.css';

function FilterLayout({ searchSlot, filterSlot, className = "" }) {
  return (
    <div className={`ui-filter-layout ${className}`}>
      <div className="ui-filter-layout__search">
        {searchSlot}
      </div>
      <div className="ui-filter-layout__filters">
        {filterSlot}
      </div>
    </div>
  );
}

export default FilterLayout;
